// Types related to Payments and Charges

export enum PaymentGateway {
  STRIPE = "STRIPE",
  PAYPAL = "PAYPAL"
}

export enum PaymentMethod {
  CREDIT_CARD = "CREDIT_CARD"
}

export enum PaymentType {
  PAYMENT_LINK = "PAYMENT_LINK"
}

export enum PaymentStatus {
  PENDING = "PENDING",
  EXPIRED = "EXPIRED",
  REFUNDED = "REFUNDED",
  CANCELLED = "CANCELLED",
  APPROVED = "APPROVED",
  CAPTURED = "CAPTURED",
  FAILED = "FAILED"
}

export enum ChargeStatus {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED"
}

export interface ProductDto {
  id?: string;
  identifier?: string;
  name?: string;
  description?: string;
  currency?: string;
  unitAmount?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface PaymentItemDto {
  product?: ProductDto;
  currency?: string;
  unitAmount?: number;
  quantity?: number;
}

export interface PaymentDto {
  id?: string;
  url?: string;
  charge_id: string;
  correlation_id?: string;
  identifier?: string;
  payment_identifier?: string;
  application_id?: string;
  payment_gateway?: PaymentGateway;
  payment_method?: PaymentMethod;
  payment_type?: PaymentType;
  payment_status?: PaymentStatus;
  payment_items?: PaymentItemDto[];
  receipt_url?: string;
  paid_at?: string;
  notified_at?: string;
  created_at?: string;
  updated_at?: string;
  // Referência opcional à cobrança relacionada
  charge?: ChargeDto;
}

export interface ChargeDto {
  id?: string;
  description: string;
  currency?: string;
  quantity?: number;
  amount: number;
  user_id: string;
  charge_status?: ChargeStatus;
  due_date: string; // formato de data (YYYY-MM-DD)
  paid_at?: string; // formato de data (YYYY-MM-DD)
  created_at?: string;
  updated_at?: string;
}

// Resposta paginada para cobranças
export interface PaginatedResponseChargeDto {
  content: ChargeDto[];
  current_page: number;
  page_size: number;
  total_elements: number;
}

// Resposta paginada para pagamentos
export interface PaginatedResponsePaymentDto {
  content: (PaymentDto & { charge?: ChargeDto })[];
  current_page: number;
  page_size: number;
  total_elements: number;
}